import React from 'react';
import Icon from 'components/mweb/Icon/Icon';
import Button from '../../common/Button/Button';
import { PAYMENT_GATEWAYS } from 'hb-redux-store/util/constantServices';
import Drawer from '../../common/Drawer';
import Input from '../../mweb/Input/Input';

const Wallets = props => {
  const {
    title,
    details,
    selectedMode,
    onPaymentModeChange,
    onPlaceOrder,
    pgId,
    ctaText = 'Place Order',
  } = props;
  const [showMoreWallets, setMoreWalletsModal] = React.useState(false);
  const [searchKey, setSearchKey] = React.useState('');
  const [walletList, setWalletList] = React.useState(
    details.map(wallet => ({
      ...wallet,
      isSelected: selectedMode === wallet.code,
    }))
  );
  const onCancel = () => setMoreWalletsModal(false);
  const filterWallets = ({ searchKey }) => {
    setSearchKey(searchKey);
    onPaymentModeChange(null);
    setWalletList(
      details.filter(
        wallet =>
          wallet.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1
      )
    );
  };
  const selectWallet = walletCode => {
    onPaymentModeChange(walletCode);
    setWalletList(
      walletList.map(wallet => ({
        ...wallet,
        isSelected: walletCode === wallet.code,
      }))
    );
  };
  // const wallet = {name: "airtelmoney", code: "airtelmoney"};
  let shortListWallets = [
    { name: 'PhonePe', code: 'phonepe', image: 'icon-payment-wallet-phonepe' },
    { name: 'PayTm', code: 'paytm', image: 'icon-payment-wallet-paytm' },
    {
      name: 'Freecharge',
      code: 'freecharge',
      image: 'icon-payment-wallet-freecharge',
    },
    { name: 'PayZapp', code: 'payzapp', image: 'icon-payment-wallet-payzapp' },
  ];
  if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
    shortListWallets = [
      {
        name: 'PhonePe',
        code: 'PHONEPE',
        image: 'icon-payment-wallet-phonepe',
      },
      { name: 'PayTm', code: 'PAYTM', image: 'icon-payment-wallet-paytm' },
      {
        name: 'Freecharge',
        code: 'FREC',
        image: 'icon-payment-wallet-freecharge',
      },
      { name: 'PayZapp', code: 'PAYZ', image: 'icon-payment-wallet-payzapp' },
    ];
  }
  const trimmedList = details
    .map(allWallets =>
      shortListWallets.find(
        bank => bank.code.toLowerCase() === allWallets.code.toLowerCase()
      )
    )
    .filter(b => !!b);
  const onPay = () => {
    const payDetails = {
      method: 'wallet',
      wallet: selectedMode,
      mode: 'pol',
      payVia: 'wallet',
    };
    if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
      payDetails.pg = 'CASH';
      payDetails.bankcode = selectedMode;
    }

    onPlaceOrder(payDetails);
  };
  const getWalletIcon = wallet => {
    const WALLET_ICONS = [
      'payzapp',
      'freecharge',
      'phonepe',
      'amazonpay',
      'paytm',
    ];
    let walletIcon = 'icon-payment-wallet-generic';
    if (WALLET_ICONS.indexOf(wallet.toLowerCase()) > -1) {
      walletIcon = 'icon-payment-wallet-' + wallet.toLowerCase();
    }
    return walletIcon;
  };
  return (
    <React.Fragment>
      <div className="desktop-payment-mode-panel">
        <div className="desktop-payment-mode-panel--title">{title}</div>
        {trimmedList?.length > 0 && (
          <React.Fragment>
            {trimmedList.map(wallet => {
              return (
                <React.Fragment key={wallet.code}>
                  <div
                    className={`desktop-payment-mode-panel--item no-cta ${
                      selectedMode === wallet.code ? 'active' : ''
                    }`}
                    onClick={() => onPaymentModeChange(wallet.code)}
                  >
                    <div className="desktop-payment-mode-panel--item--illustration">
                      <Icon class={wallet.image} height={26} width={45} />
                    </div>
                    <div className="desktop-payment-mode-panel--item--name">
                      {wallet.name}
                    </div>
                    <div className="desktop-payment-mode-panel--item--radio">
                      {selectedMode === wallet.code ? (
                        <Icon size={17} class="icon-common-radio-selected" />
                      ) : (
                        <Icon size={17} class="icon-common-radio-unselected" />
                      )}
                    </div>
                  </div>
                  {selectedMode === wallet.code && (
                    <div className="saved-wallet-cta">
                      <Button
                        className="button button-primary medium"
                        onClick={onPay}
                      >
                        {ctaText}
                      </Button>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
            <div className="desktop-payment-mode-panel--cta">
              <Button
                className="desktop-payment-mode-panel--add-card button action-link more"
                onClick={() => setMoreWalletsModal(true)}
              >
                View More Wallets
              </Button>
            </div>
          </React.Fragment>
        )}
      </div>
      <div className="desktop-payments-section-divider"></div>
      <Drawer
        title="Select Your Wallet"
        placement="right"
        closable={true}
        onClose={onCancel}
        visible={showMoreWallets}
        destroyOnClose={true}
        maskClosable={false}
        width={500}
        footer={
          <div className="desktop-desktop-more-net-banks--cta">
            <Button
              className="button button-primary full-width large"
              onClick={onPay}
            >
              Proceed to Pay
            </Button>
          </div>
        }
        className="desktop-more-net-banks"
      >
        <Input
          className="desktop-more-net-banks--search-box"
          type={'text'}
          onChange={filterWallets}
          placeholder="Search for preferred wallet"
          autoFocus
          value={searchKey}
          name="searchKey"
          clearText
          search
        />
        <div className="desktop-more-net-banks--list">
          {walletList.map(wallet => {
            return (
              <div
                className="desktop-more-net-banks--item"
                key={wallet.code}
                onClick={() => selectWallet(wallet.code)}
              >
                <div className="desktop-more-net-banks--name">
                  {wallet.name}
                </div>
                <div className="desktop-more-net-banks--radio">
                  {selectedMode === wallet.code ? (
                    <Icon size={20} class="icon-common-radio-selected" />
                  ) : (
                    <Icon size={20} class="icon-common-radio-unselected" />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </Drawer>
    </React.Fragment>
  );
};

export default Wallets;
